export const FLOW_STEPS = ['Questionário', 'Tratamento', 'Pedido']
